import React from "react";
import useLocationNav from "../../Navbar/useLocationNav";

import { NavMenu, NavItem, Navlinks, H3links } from "./NavMenu.Styles";
import { useLocation } from "react-router-dom";

const NavMenus = changeColor => {
	const location = useLocation();
	useLocationNav(location);

	return (
		<NavMenu>
			<NavItem>
				<Navlinks to="/#brand">
					<H3links changeColor={changeColor}>Brands</H3links>
				</Navlinks>
			</NavItem>
			<NavItem>
				<Navlinks to="/#discover">
					<H3links changeColor={changeColor}>Discover</H3links>
				</Navlinks>
			</NavItem>
			<NavItem>
				<Navlinks to="/#maps">
					<H3links changeColor={changeColor}>Maps</H3links>
				</Navlinks>
			</NavItem>
		</NavMenu>
	);
};

export default NavMenus;
